import React, { useState } from "react";
import styles from "./PlatformGeneratedVouchers.module.scss";
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { platformGeneratedVouchersTableData } from "../../../../../views/AdminPortal/dummyData";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import VoucherDetail from "./VoucherDetail/VoucherDetail";
import VoucherCreationForm from "./VoucherCreationForm/VoucherCreationForm";

const platformGeneratedVouchersData = [
    { title: "Total vouchers issued", value: 0 },
    { title: "Active vouchers", value: 0 },
    { title: "Redeemed vouchers", value: 0 },
    { title: "Expired vouchers", value: 0 },
].map((item) => ({
    ...item,
    title: item.title.toUpperCase(),
}));

const PlatformGeneratedVouchers = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);

    const options = [
        { label: "View details", action: () => setViewDetails(true) },
        { label: "Edit" },
        { label: "Change Status" },
        { label: "Delete" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Voucher Name",
            selector: (row) => row.voucherName,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Voucher Code",
            selector: (row) => row.voucherCode,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Voucher Type",
            selector: (row) => row.voucherType,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Validity Period",
            selector: (row) => row.validityPeriod,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Value",
            selector: (row) => row.value,
            center: "true",
        },
        {
            name: "Conditions",
            selector: (row) => row.conditions,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Applicability",
            selector: (row) => row.applicability,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Redemption",
            selector: (row) => row.redemption,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            center: "true",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.platformGeneratedContainer}>
            <div className={styles.overviewWrapper}>
                <h5 className={styles.mainHeading}>Overview</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={platformGeneratedVouchersData} />
                </div>
            </div>

            {!viewDetails && !isOpen ? (
                <div className={styles.filterTableWrapper}>
                    <div className={styles.headingBtnWrapper}>
                        <h5 className={styles.sectionHeading}>Platform-Generated Vouchers</h5>
                        <div className={styles.btnContainer}>
                            <DynamicButton theme="yellow" onClick={() => setIsOpen(true)}>
                                Create New Voucher
                            </DynamicButton>
                        </div>
                    </div>
                    <DynamicTableFilters
                        componentName={"Platform-Generated Vouchers"}
                        onApply={handleApply}
                        onClear={handleClear}
                    />
                    <div className={styles.tableWrapper}>
                        <DynamicDatatable
                            data={platformGeneratedVouchersTableData}
                            columns={columns}
                            type="gray"
                            pagination
                            highlightOnHover
                            responsive
                        />
                    </div>
                </div>
            ) : viewDetails ? (
                <VoucherDetail setViewDetails={setViewDetails} />
            ) : (
                <VoucherCreationForm setIsOpen={setIsOpen} />
            )}
        </div>
    );
};

export default PlatformGeneratedVouchers;